"use strict";

exports.__esModule = true;
exports.TIMELINE_WIDGET = exports.RAW_DATA_WIDGET = exports.OTHER_WIDGET = exports.METRIC_WIDGET = exports.LAYOUT_WIDGET = exports.KNOWLEDGE_BASE_WIDGET = exports.DIGITAL_LOG_WIDGET = exports.DEVICE_INFORMATION_WIDGET = exports.ACTION_WIDGET = void 0;
var LAYOUT_WIDGET = exports.LAYOUT_WIDGET = "layout";
var DEVICE_INFORMATION_WIDGET = exports.DEVICE_INFORMATION_WIDGET = "deviceInformation";
var TIMELINE_WIDGET = exports.TIMELINE_WIDGET = "timeline";
var METRIC_WIDGET = exports.METRIC_WIDGET = "metric";
var ACTION_WIDGET = exports.ACTION_WIDGET = "action";
var RAW_DATA_WIDGET = exports.RAW_DATA_WIDGET = "rawData";
var DIGITAL_LOG_WIDGET = exports.DIGITAL_LOG_WIDGET = "digitalLog";
var KNOWLEDGE_BASE_WIDGET = exports.KNOWLEDGE_BASE_WIDGET = "knowledgeBase";
var OTHER_WIDGET = exports.OTHER_WIDGET = "other";